jQuery(document).ready(function ($) {
  $('#menu-toggle').click(function () {
    $(document.body).toggleClass('show-menu');
    $(this).toggleClass('opened');
  });
});
/* 
document.addEventListener('DOMContentLoaded', () => {
  const headerNav = document.getElementById('site-header-container');
  const main = document.querySelector('main');

  if (main) {
    const observer = new IntersectionObserver(
      () => {
        if (window.pageYOffset === 0) {
          headerNav.classList.remove('document-scrolled');
        } else {
          headerNav.classList.add('document-scrolled');
        }
      },
      {
        rootMargin: '1px',
        threshold: 0,
      }
    );

    observer.observe(main);
  }
});
 */
